import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components/macro';
import tw from 'tailwind.macro';
// Custom components
import AppLink from '../../../components/AppLink';
import { buttonSubmitStyle } from '../../../components/ButtonSubmit';
import faqCategoriesEN from '../../../data/faq/en/categories';
import faqCategoriesFR from '../../../data/faq/fr/categories';
// Constants
import { FR } from '../../LanguageProvider/constants';
import Categories from './Categories';
// Messages translation
import messages from './messages';

const Content = styled.div`
  ${tw`rounded-lg m-auto mt-abs2
    mx-abs2 lg:mt-0 lg:mx-0`}
  width: 90%;
  @media (min-width: 992px) {
    width: 32%;
    margin-top: 4.5rem;
    margin-right: 3.5rem;
    position: sticky;
    top: 7rem;
  }
`;

const TicketButton = css`
  ${buttonSubmitStyle}
  ${tw`text-center mx-0 mb-0`}
  @media (min-width: 992px) {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  padding: 1.5rem;
  margin-bottom: 1.5rem;
`;

const StickyMenu = ({ categoryName, locale, redirectHome }) => (
  <Content>
    <Categories
      categories={locale === FR ? faqCategoriesFR : faqCategoriesEN}
      categoryName={categoryName}
      redirectHome={redirectHome}
    />
    <FormattedMessage {...messages.buyTicket}>
      {(msg) => (
        <AppLink
          id="redirectToSearch"
          mustReload={false}
          name={msg}
          styles={TicketButton}
          url="/"
        />
      )}
    </FormattedMessage>
  </Content>
);

StickyMenu.propTypes = {
  categoryName: PropTypes.string,
  locale: PropTypes.string,
  redirectHome: PropTypes.func,
};

export default StickyMenu;
